import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
  list: [],
  user: null,
  error: "",
  loading: false,
};

export const addIndivisualUser = createAsyncThunk(
  "user/addIndivisualUser",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        // url: `user/register`,
        url: `user/indivisualRegister`,
        data: {
          ...values,
        },
      });
      toast.success("Registration successful");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding user try again");
      console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/change-password`,
        data: {
          ...values,
        },
      });
      toast.success("Change Password successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in Change Password try again");
      console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "user/forgotPassword",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/forgot-password`,
        data: {
          ...values,
        },
      });
      toast.success("Password reset email sent successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error sending password reset email";
      toast.error(errorMessage);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const postBankDetails = createAsyncThunk(
  "user/postBankDetails",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        // url: `user/register`,
        url: `user/BankDetails`,
        data: {
          ...values,
        },
      });
      toast.success("Bank Details add successful");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding bank details try again");
      console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const addSensitiveDetails = createAsyncThunk(
  "user/addSensitiveDetails",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        // url: `user/register`,
        url: `user/addSensitiveDetails`,
        data: {
          ...values,
        },
      });
      toast.success("Sensitive Details add successful");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding sensitive details try again");
      console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const addStaff = createAsyncThunk("user/addStaff", async (values) => {
  try {
    console.log("slice values", values);
    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
      url: `user/register`,
      data: {
        ...values,
      },
    });
    toast.success("Registration successful");
    return {
      data,
      message: "success",
    };
  } catch (error) {
    // Handle specific validation errors
    if (error.response && error.response.data) {
      const errorData = error.response.data;

      // Check for duplicate fields error
      if (errorData.duplicateFields) {
        toast.error(errorData.message || "Duplicate fields found");
      }
      // Handle other specific error messages from backend
      else if (errorData.message) {
        toast.error(errorData.message);
      }
      // Generic error message as fallback
      else {
        toast.error("Error in adding staff. Please try again.");
      }
    } else {
      toast.error("Error in adding staff. Please try again.");
    }

    console.error("Error details:", error.response?.data || error.message);
    return {
      message: "error",
      error: error.response?.data || error.message,
    };
  }
});

// Delete or inactive user status 0
export const deleteStaff = createAsyncThunk("user/deleteStaff", async (id) => {
  try {
    const resp = await axios({
      method: "patch",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `user/${id}`,
    });
    return resp.data;
  } catch (error) {
    console.log(error.message);
  }
});

// Delete Staff permanent Status 2
export const deleteStaffPermanent = createAsyncThunk(
  "user/deleteStaffPermanent",
  async (id) => {
    try {
      const resp = await axios({
        method: "delete",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/${id}`,
      });
      return resp.data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

export const ActiveUser = createAsyncThunk("user/activeUser", async (id) => {
  try {
    const resp = await axios({
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `user/activeUser/${id}`,
    });
    return resp.data;
  } catch (error) {
    console.log(error.message);
  }
});

export const loadSingleStaff = createAsyncThunk(
  "user/loadSingleStaff",
  async (id) => {
    try {
      const data = await axios.get(`user/${id}`);
      return data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

export const loadAllStaff = createAsyncThunk(
  "user/loadAllStaff",
  async ({ status }) => {
    try {
      const { data } = await axios.get(`user?status=${status}`);
      console.log("Loaded Staff Data:", data);
      return data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

export const getLeavePolicyAndAllocation = createAsyncThunk(
  "user/getLeavePolicyAndAllocation",
  async ({ companyId, id }) => {
    try {
      // Use template literals to inject the company_id and userId
      const { data } = await axios.get(
        `user/get/LeavePolicy?company_id=${companyId}&userId=${id}`
      );
      console.log("Loaded Staff Data:", data);
      return data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

export const sendWelcomeEmail = createAsyncThunk(
  "users/sendWelcomeEmail",
  async (userId, { rejectWithValue }) => {
    try {
      console.log("sliceUserId", userId);

      const response = await axios({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        url: "user/send-welcome-email",
        data: { userId },
      });
      console.log("checkResponse", response);

      if (response.status != 200) throw new Error("Failed to send email");

      return await response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const loadTodaysBirthdays = createAsyncThunk(
  "users/loadTodaysBirthdays",
  async () => {
    const response = await axios.get("user/birthdays");
    console.log("API Response>>>>>:", response.data);
    return response.data;
  }
);

export const loadUpcomingBirthdays = createAsyncThunk(
  "users/loadUpcomingBirthdays",
  async () => {
    const response = await axios.get("user/getUpcomingBirthdays");
    console.log("API Response<<<<<:", response.data);
    return response.data;
  }
);

export const getUserDevices = createAsyncThunk(
  "user/getUserDevices",
  async () => {
    const response = await axios.get("user/getUserDevices");
    console.log("API Response>>>>>:", response.data);
    return response.data;
  }
);

export const getCompanyOfficeMaster = createAsyncThunk(
  "user/getCompanyOfficeMaster",
  async () => {
    const response = await axios.get("user/getCompanyOfficeMaster");
    console.log("API Response>>>>>:", response.data);
    return response.data;
  }
);

export const addUser = createAsyncThunk("user/addUser", async (values) => {
  try {
    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `user/login`,
      data: {
        ...values,
      },
    });
    localStorage.setItem("access-token", data.token);
    localStorage.setItem("role", data.role);
    localStorage.setItem("roleId", data.roleId);
    localStorage.setItem("user", data.userName);
    localStorage.setItem("id", data.id);
    localStorage.setItem("isLogged", true);
    localStorage.setItem("company_id", data.company_id);
    localStorage.setItem("requirePasswordChange", data.requirePasswordChange);
    toast.success(" Login Successfully Done");
    console.log("hh", data);

    return {
      data,
      message: "success",
    };
  } catch (error) {
    console.log(error.message);
    toast.error("Incorrect Username or Password !");
    return {
      message: "error",
    };
  }
});

// Update User Information

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async ({ id, values }) => {
    try {
      const { data } = await axios({
        method: "put",
        url: `user/${id}`,
        data: {
          ...values,
        },
      });
      toast.success("User Information Updated Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      // Handle validation errors
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        // Check for duplicate fields error
        if (errorData.duplicateFields) {
          toast.error(errorData.message);
        }
        // Handle other specific error messages
        else if (errorData.message) {
          toast.error(errorData.message);
        }
        // Generic error for unknown cases
        else {
          toast.error("Error in updating user information");
        }
      } else {
        toast.error("Error in updating user information");
      }

      console.error("Update error:", error.response?.data || error.message);
      return {
        message: "error",
        error: error.response?.data || error.message,
      };
    }
  }
);
export const updateBankDetails = createAsyncThunk(
  "user/updateBankDetails",
  async ({ id, values }) => {
    try {
      const { data } = await axios({
        method: "put",
        url: `user/bankDetails/${id}`,
        data: {
          ...values,
        },
      });
      toast.success("Bank Details Updated Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      console.log(error.message);
      toast.error("Error in updating Bank Details");
      return {
        message: "error",
      };
    }
  }
);

export const updateSensitiveDetails = createAsyncThunk(
  "user/updateSensitiveDetails",
  async ({ id, values }) => {
    try {
      const { data } = await axios({
        method: "put",
        url: `user/updateSensitiveDetails/${id}`,
        data: {
          ...values,
        },
      });
      toast.success("Sensitive Details Updated Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      console.log(error.message);
      toast.error("Error in updating Sensitive Details");
      return {
        message: "error",
      };
    }
  }
);

export const updateLeaveAllocation = createAsyncThunk(
  "user/updateLeaveAllocation",
  async ({ values }) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `user/updateLeaveAllocation`,
        data: {
          ...values,
        },
      });
      // toast.success(" Leave Allocation Updated Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      console.log(error.message);
      toast.error("Error in updating Sensitive Details");
      return {
        message: "error",
      };
    }
  }
);
// Add this to your userSlice
export const removeBiometric = createAsyncThunk(
  "user/removeBiometric",
  async (id) => {
    try {
      const response = await axios.delete(`user/removeBiometric/${id}`);
      toast.success("Biometric data removed successfully");
      return id; // Return the ID of the removed biometric
    } catch (error) {
      toast.error("Error removing biometric data");
      console.log(error.message);
      return Promise.reject(error.message);
    }
  }
);

export const getBankDetailsByUserId = createAsyncThunk(
  "user/getBankDetailsByUserId",
  async (userId) => {
    try {
      const data = await axios.get(`user/bankDetails/${userId}`);
      return data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

export const getCompanyNameByClientId = createAsyncThunk(
  "user/getCompanyNameByClientId",

  async (id) => {
    console.log("done");

    try {
      const data = await axios.get(`user/getCompanyNameByClientId/${id}`);
      return data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUser: (state) => {
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    // 1) ====== builders for loadAllStaff ======

    builder.addCase(loadAllStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadAllStaff.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    });

    builder.addCase(loadAllStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 1) ====== builders for getLeavePolicyAndAllocation ======

    builder.addCase(getLeavePolicyAndAllocation.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getLeavePolicyAndAllocation.fulfilled, (state, action) => {
      state.loading = false;
      state.leaveData = action.payload;
    });

    builder.addCase(getLeavePolicyAndAllocation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 1) ====== builders for getCompanyOfficeMaster ======

    builder.addCase(getCompanyOfficeMaster.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getCompanyOfficeMaster.fulfilled, (state, action) => {
      state.loading = false;
      state.officeName = action.payload;
    });

    builder.addCase(getCompanyOfficeMaster.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2) ====== builders for addStaff ======

    builder.addCase(addStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addStaff.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(addStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for getBankDetailsByUserId ======

    builder.addCase(getBankDetailsByUserId.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getBankDetailsByUserId.fulfilled, (state, action) => {
      state.loading = false;

      state.user = action.payload.data;
    });

    // 2.1) ====== builders for addIndivisualUser ======

    builder.addCase(addIndivisualUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addIndivisualUser.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(addIndivisualUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2.2) ====== builders for changePassword ======

    builder.addCase(changePassword.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(changePassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 3) ====== builders for addUser ======

    builder.addCase(addUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addUser.fulfilled, (state, action) => {
      state.loading = false;

      if (!Array.isArray(state.user)) {
        state.user = [];
      }
      const user = [...state.user];
      user.push(action.payload.data);
      state.user = user;
    });

    builder.addCase(addUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for updateUser ======

    builder.addCase(updateUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(updateUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for updateSensitiveDetails ======

    builder.addCase(updateSensitiveDetails.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateSensitiveDetails.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(updateSensitiveDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for updateLeaveAllocation ======

    builder.addCase(updateLeaveAllocation.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateLeaveAllocation.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(updateLeaveAllocation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for loadSingleStaff ======

    builder.addCase(loadSingleStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadSingleStaff.fulfilled, (state, action) => {
      state.loading = false;

      state.user = action.payload.data;
    });

    builder.addCase(loadSingleStaff.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.error = action.payload.message;
    });

    // 2.1) ====== builders for postBankDetails ======

    builder.addCase(postBankDetails.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(postBankDetails.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(postBankDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2.1) ====== builders for addSensitiveDetails ======

    builder.addCase(addSensitiveDetails.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addSensitiveDetails.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(addSensitiveDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for getCompanyNameByClientId ======

    builder.addCase(getCompanyNameByClientId.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getCompanyNameByClientId.fulfilled, (state, action) => {
      state.loading = false;

      state.companyName = action.payload.data;
    });

    builder.addCase(getCompanyNameByClientId.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.error = action.payload.message;
    });

    // 5) ====== builders for loadTodaysBirthdays ======

    builder.addCase(loadTodaysBirthdays.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadTodaysBirthdays.fulfilled, (state, action) => {
      const bday = action.payload;
      console.log("todaybirthday", bday);
      state.loading = false;
      state.todaysBirthdays = action.payload;
    });

    builder.addCase(loadTodaysBirthdays.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.error = action.payload.message;
    });

    // 5) ====== builders for sendWelcomeEmail ======

    builder.addCase(sendWelcomeEmail.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(sendWelcomeEmail.fulfilled, (state, action) => {
      const bday = action.payload;
      console.log("todaybirthday", bday);
      state.loading = false;
      state.todaysBirthdays = action.payload;
    });

    builder.addCase(sendWelcomeEmail.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.error = action.payload.message;
    });

    // 6) ====== builders for loadUpcomingBirthdays ======

    builder.addCase(loadUpcomingBirthdays.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadUpcomingBirthdays.fulfilled, (state, action) => {
      const upcomingbday = action.payload;
      console.log("upcomingbday", upcomingbday);
      state.loading = false;
      state.upcomingBirthdays = action.payload;
    });

    builder.addCase(loadUpcomingBirthdays.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.error = action.payload.message;
    });

    // 6) ====== builders for getUserDevices ======

    builder.addCase(getUserDevices.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getUserDevices.fulfilled, (state, action) => {
      state.loading = false;
      state.userDeviceDetails = action.payload;
      state.total = action.payload.length; // Adjust this if necessary
    });

    builder.addCase(getUserDevices.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.error = action.payload.message;
    });

    // 7) ====== builders for deleteStaff ======

    builder.addCase(deleteStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(deleteStaff.fulfilled, (state, action) => {
      state.loading = false;

      const filterUser = state.list.filter(
        (staff) => staff.id !== parseInt(action.payload) && staff
      );

      state.list = filterUser;
    });

    builder.addCase(deleteStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    builder.addCase(ActiveUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(ActiveUser.fulfilled, (state, action) => {
      state.loading = false;

      const filterUser = state.list.filter(
        (staff) => staff.id !== parseInt(action.payload) && staff
      );

      state.list = filterUser;
    });

    builder.addCase(ActiveUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
    // 7) ====== builders for deleteStaffPermanent ======

    builder.addCase(deleteStaffPermanent.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(deleteStaffPermanent.fulfilled, (state, action) => {
      state.loading = false;

      const filterUser = state.list.filter(
        (staff) => staff.id !== parseInt(action.payload) && staff
      );

      state.list = filterUser;
    });

    builder.addCase(deleteStaffPermanent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 8) ====== builders for removeBiometric ======

    // Add this to the extraReducers in your userSlice
    builder.addCase(removeBiometric.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(removeBiometric.fulfilled, (state, action) => {
      state.loading = false;
      state.userDeviceDetails = state.userDeviceDetails.filter(
        (device) => device.userDeviceId !== action.payload
      );
    });

    builder.addCase(removeBiometric.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default userSlice.reducer;
export const { clearUser } = userSlice.actions;
